import axios from "axios";
import {
  Message
} from 'element-ui';
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api';   //开发环境
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = '/onLine';   //生产环境
}
// 设置请求超出时间
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
// post 请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';  //添加请求头
// axios请求拦截器    为所有的axios请求添加请求头
axios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('token')) {     //判断token是否为空
      config.headers['satoken'] = sessionStorage.getItem('token');
    }
    return config;
  },
  error => {
    return Promise.error(error);
  }
)
// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status) {
      if (response.status === 777) {
        Message({
          type: 'error',
          message: '您的账号在其他地方登录，请重新登录',
          showClose: true
        });
        this.$router.push("/")

        return
      } else if (response.status === 200) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    }
  },
  error => {
    if (error.response.status) {
      return
    }
  }
)

// 封装get请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

// 封装post请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        if (res.data.status == "222") {
          this.$message({
            type: 'error',
            message: res.data.message,
            showClose: true
          })
          this.$router.push('/')
        }
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}